import { DEFAULT_AVATAR } from "../api/client";

/** Canonical avatar sizes used across the app (and Storybook). */
export type AvatarSize = "sm" | "md" | "lg" | "xl" | "nav";

const SIZE_CLASS: Record<AvatarSize, string> = {
  sm: "ne__avatar--sm",
  md: "ne__avatar--md",
  lg: "ne__avatar--lg",
  xl: "ne__avatar--xl",
  nav: "ne__avatar--nav",
};

export function Avatar({
  src,
  alt = "",
  size = "md",
  className = "",
}: {
  src?: string | null;
  alt?: string;
  /** Fixed size so avatars never stretch full-width in Storybook or loose layouts. */
  size?: AvatarSize;
  className?: string;
}) {
  const classes = ["ne__avatar", SIZE_CLASS[size], className]
    .filter(Boolean)
    .join(" ");

  return (
    <figure className={classes}>
      <img src={src || DEFAULT_AVATAR} alt={alt} />
    </figure>
  );
}
